export const HIGHLIGHT_ITEMS = [
  'evidence',
  '3cnet',
  '3asc',
  'clinical-team',
] as const;

// 영상 재생 위치 2.5초마다 EVIDENCE(0초) → 3Cnet → 3ASC → 임상유전학팀 순으로 누적 활성화한다.
export const HIGHLIGHT_STAGE_INTERVAL_SECONDS = 2.5;

export function getHighlightActiveCount(seconds: number) {
  return Math.min(
    HIGHLIGHT_ITEMS.length,
    1 + Math.floor(Math.max(0, seconds) / HIGHLIGHT_STAGE_INTERVAL_SECONDS),
  );
}

// 모바일은 영상 시점 대신 항목이 화면에 이 비율 이상 보이면 켠다. 목록 전체의 진행률로
// 나누면 아래 항목이 화면에 들어오기도 전에 켜진다.
export const MOBILE_HIGHLIGHT_VISIBLE_RATIO = 1;

// 위에서부터 차례로, 화면에 기준 비율 이상 들어온(또는 이미 지나간) 항목 수.
export function getMobileHighlightActiveCount(
  items: ReadonlyArray<Pick<DOMRect, 'top' | 'height'>>,
  viewportHeight: number,
) {
  let count = 0;
  for (const { top, height } of items) {
    if (top + height * MOBILE_HIGHLIGHT_VISIBLE_RATIO > viewportHeight) break;
    count += 1;
  }
  return count;
}
